@if (card(); as current) {
<div class="draft-card" automation-id="canvas-draft-card">
    <p-icon name="file-text" size="sm" color="functional-default"></p-icon>
    <span class="title">{{ current.title ?? ('aichat.canvas.draft.card.title' | translate) }}</span>
    <span class="separator" aria-hidden="true">|</span>
    <span>{{ current.countKey | translate: { count: current.count } }}</span>
    <span>· {{ 'aichat.canvas.draft.card.version' | translate: { version: current.version } }} ·</span>
    <span>{{ current.stateKey | translate }}</span>
</div>
}
